

const currentYear = new Date().getFullYear();
document.querySelectorAll(".current-year").forEach(el => {
    el.textContent = currentYear;
});

function getTimeRemaining(endtime) {
  var t = Date.parse(endtime) - Date.parse(new Date());
  var seconds = Math.floor((t / 1000) % 60);
  var minutes = Math.floor((t / 1000 / 60) % 60);
  var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
  var days = Math.floor(t / (1000 * 60 * 60 * 24));

  return {
    total: t,
    days: days,
    hours: hours,
    minutes: minutes,
    seconds: seconds,
  };
}

function initializeClock(className) {
  var clocks = document.getElementsByClassName(className);
  Array.prototype.forEach.call(clocks, function (clock) {
    var endtime = clock.dataset.endtime;

    var countdownDiv = clock.closest(".countdown");
    var daysSpan = clock.querySelector(".days");
    var hoursSpan = clock.querySelector(".hours");
    var minutesSpan = clock.querySelector(".minutes");
    var secondsSpan = clock.querySelector(".seconds");

    function updateClock() {
      var t = getTimeRemaining(endtime);

      if (t.total <= 0) {
        countdownDiv.style.display = "none";
        clearInterval(timeinterval);
        return;
      }

      daysSpan.innerHTML = t.days >= 0 ? ("0" + t.days).slice(-2) : "";
      hoursSpan.innerHTML = t.hours >= 0 ? ("0" + t.hours).slice(-2) : "";
      minutesSpan.innerHTML = t.minutes >= 0 ? ("0" + t.minutes).slice(-2) : "";
      secondsSpan.innerHTML = t.seconds >= 0 ? ("0" + t.seconds).slice(-2) : "";
    }

    updateClock();
    var timeinterval = setInterval(updateClock, 1000);
  });
}

initializeClock("clockdiv");

document.addEventListener("DOMContentLoaded", function () {
    const searchInput = document.getElementById("predictive-search");
    const searchResult = document.getElementById("search-result");
    const collectionResult = document.getElementById("collection-result");
    const productResult = document.getElementById("product-result");
    const pageResult = document.getElementById("page-result");
    const blogResult = document.getElementById("blog-result");
    const suggestionHeading = document.getElementById("suggestion-result-heading");
    const productHeading = document.getElementById("product-result-heading");

    if (!searchInput) return;

    searchInput.addEventListener("input", function () {
        const query = this.value.trim();
        triggerPredictiveSearch(query);
    });
    function triggerPredictiveSearch(query) {
        if (!query || query.length <= 0) {
            clearSearchResults();
            return;
        }

        fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,article,collection,page`)
            .then(response => response.json())
            .then(data => {
                displaySearchResults(
                    data.resources.results.collections || [],
                    data.resources.results.products || [],
                    data.resources.results.pages || [],
                    data.resources.results.articles || []
                );
            })
            .catch(error => console.error("Error fetching search results:", error));
    }


    function displaySearchResults(collections, products, pages, articles) {
        clearSearchResults();

        const query = searchInput.value.trim();
        if (!query) return;

        const queryRegex = new RegExp(`(${escapeRegExp(query)})`, "gi");
        let hasSuggestions = false;

        hasSuggestions = true;
        if (suggestionHeading) suggestionHeading.classList.remove("d-none");

        if (collections.length > 0 && collectionResult) {
            collections.forEach(collection => {
                const highlightedTitle = collection.title.replace(queryRegex, `<span class="highlight">$1</span>`);
                collectionResult.innerHTML += createSearchItem(collection.url, highlightedTitle, "Collection");
            });
        }

        if (pages.length > 0 && collectionResult) {
            pages.forEach(page => {
                const highlightedTitle = page.title.replace(queryRegex, `<span class="highlight">$1</span>`);
                collectionResult.innerHTML += createSearchItem(page.url, highlightedTitle, "Page");
            });
        }

        if (articles.length > 0 && collectionResult) {
            articles.forEach(article => {
                const highlightedTitle = article.title.replace(queryRegex, `<span class="highlight">$1</span>`);
                collectionResult.innerHTML += createSearchItem(article.url, highlightedTitle, "Blog");
            });
        }

        if (products.length > 0 && collectionResult) {
            products.forEach(product => {
                const highlightedTitle = product.title.replace(queryRegex, `<span class="highlight">$1</span>`);
                collectionResult.innerHTML += createSearchItem(product.url, highlightedTitle, "Product");
            });
        }

        if (products.length > 0 && productResult) {
            if (productHeading) productHeading.classList.remove("d-none");
            products.forEach(product => {
                productResult.innerHTML += createProductItem(product);
            });
        } else {
            if (productHeading) productHeading.classList.add("d-none");
        }

        if (searchResult) {
            if (hasSuggestions) {
                searchResult.classList.add("active");
            } else {
                searchResult.classList.remove("active");
            }
        }
    }

    function escapeRegExp(string) {
        return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }

    function clearSearchResults() {
        if (collectionResult) collectionResult.innerHTML = "";
        if (productResult) productResult.innerHTML = "";
        if (pageResult) pageResult.innerHTML = "";
        if (blogResult) blogResult.innerHTML = "";
        if (suggestionHeading) suggestionHeading.classList.add("d-none");
        if (productHeading) productHeading.classList.add("d-none");
        if (searchResult) searchResult.classList.remove("active");
    }

    function formatPrice(priceInCents) {
      const price = priceInCents;
      const activeCurrency = window?.Shopify?.currency?.active || 'USD';

      let formatted = new Intl.NumberFormat('en', {
        style: 'currency',
        currency: activeCurrency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(price);

      if (activeCurrency.toUpperCase() === 'INR') {
        formatted = formatted.replace('₹', '').trim();
        return 'Rs. ' + formatted;
      }

      return formatted;
    }

    function createSearchItem(url, title, type) {
        return `
            <div class="search-result-item">
                <a href="${url}">
                    <h6>${title} <span class="type">(${type})</span></h6>
                </a>
            </div>
        `;
    }

    function createProductItem(product) {
        const hasComparePrice = product.compare_at_price && product.compare_at_price > product.price;
        return `
            <div class="search-result-item">
                <div class="product-box-6">
                    <div class="img-wrapper">
                        <div class="product-image">
                            <a href="${product.url}">
                                <img src="${product.image}&width=241" data-src="${product.image}" class="img-fluid lazy-collection" loading="lazy" alt="${product.title}" />
                            </a>
                        </div>
                    </div>
                    <div class="product-detail">
                        <div>
                            <a href="${product.url}">
                                <h6>${product.title}</h6>
                            </a>
                            <p class="price">
                                <span class="current-price">${formatPrice(product.price)}</span>
                                ${
                                    hasComparePrice
                                        ? `<span class="compare-price">${formatPrice(product.compare_at_price)}</span>`
                                        : ""
                                }
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
    document.querySelectorAll(".rapid-search a").forEach(link => {
        link.addEventListener("click", function (e) {
            e.preventDefault();

            const keyword = this.textContent.trim();
            if (!keyword || !searchInput) return;

            searchInput.value = keyword;

            triggerPredictiveSearch(keyword);
        });
    });
});


const lenis = new Lenis({ autoRaf: true, duration: 2 });

const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
tooltipTriggerList.forEach(el => new bootstrap.Tooltip(el));

const radioss = document.querySelectorAll('.custom-radio');
const formCheckss = document.querySelectorAll('.form-check');
const addressOutput = document.getElementById('selected-address');

if (radioss.length > 0) {
  const lastIndex = radioss.length - 1;
  const lastRadio = radioss[lastIndex];

  lastRadio.checked = true;
  formCheckss[lastIndex].classList.add('active-radio');

  const defaultAddress = lastRadio.dataset.address;
  if (addressOutput) addressOutput.textContent = defaultAddress;
}

radioss.forEach((radio) => {
  radio.addEventListener('change', () => {
    formCheckss.forEach(item => item.classList.remove('active-radio'));
    radio.closest('.form-check').classList.add('active-radio');

    const selectedAddress = radio.dataset.address;
    if (addressOutput) addressOutput.textContent = selectedAddress;
  });
});


    window.discountSettings = {};

    const totalBlocks = Number("4");
    window.discountSettings.discount_1_no = "";
    window.discountSettings.discount_1_off = "";
    if (totalBlocks > 1) {
        window.discountSettings.discount_2_no = "";
        window.discountSettings.discount_2_off = "";
    }
    if (totalBlocks > 2) {
        window.discountSettings.discount_3_no = "";
        window.discountSettings.discount_3_off = "";
    }
    if (totalBlocks > 3) {
        window.discountSettings.discount_4_no = "";
        window.discountSettings.discount_4_off = "";
    }

  function handleModalOpen() {
    if (document.body.classList.contains("modal-open")) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }

  const observer = new MutationObserver(handleModalOpen);
  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ["class"],
  });

  window.addEventListener("load", () => {
    const loader = document.querySelector(".skeleton_loader");
    if (loader) {
      loader.remove(); 
    }
    handleModalOpen();
  });

  function removeSkeletonFallback() {
    const loader = document.querySelector(".skeleton_loader");
    const mainContent = document.querySelector(".main-header");

    if (loader && mainContent && mainContent.offsetHeight > 0) {
      loader.remove();
    } else {
      requestAnimationFrame(removeSkeletonFallback);
    }
  }

  requestAnimationFrame(removeSkeletonFallback);

  handleModalOpen();

 document.addEventListener("DOMContentLoaded", function () {
    const images = document.querySelectorAll("img.lazy-collection");

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const img = entry.target;
                const lazySrc = img.dataset ? img.dataset.src : "";

                if (lazySrc) {
                  img.src = lazySrc;
                }

                img.onload = () => {
                    img.classList.add("lazy-loaded");
                };

                if (img.complete) {
                  img.classList.add("lazy-loaded");
                }

                observer.unobserve(img);
            }
        });
    });

    images.forEach(img => observer.observe(img));
});

document.addEventListener('DOMContentLoaded', function () {
  const timerEls = document.querySelectorAll(".product-timer");

  timerEls.forEach(function(timerEl) {
    const endTimeStr = timerEl.dataset.end;
    if (!endTimeStr) return;

    const endTime = new Date(endTimeStr).getTime();

    function updateTimer() {
      const now = Date.now();
      const distance = endTime - now;

      if (distance <= 0) {
        timerEl.textContent = "Expired";
        clearInterval(timerInterval);
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      timerEl.textContent = `${days} D : ${hours} H : ${minutes} M : ${seconds} S`;
    }

    const timerInterval = setInterval(updateTimer, 1000);
    updateTimer();
  });
});